import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import PageTemplate from './PageTemplate';
import { GetShiur } from '../Util/Shiurim';
import { getBookmark } from '../Util/Bookmarks';

const Shiur = (props) => {
  let params = useParams();
  const location = useLocation();
  const [stateDate, setStateDate] = useState(() => {
    // הגעה דרך אייקון סימניה: פותחים את יום השיעור שבו נוצרה הסימניה
    const bm = location.state?.gotoBookmark && getBookmark(params.type);
    return bm?.date ? new Date(bm.date) : new Date();
  });
  const [stateShiurData, setShiurData] = useState(null);

  useEffect(() => {
    GetShiur(params.type, stateDate).then(
      (myResolve) => {
        setShiurData(myResolve);
      },
      (myReject) => {
        setShiurData(myReject);
      }
    );        
  }, [stateDate]);


  if (!stateShiurData)
    return <h4>טוען נתונים...</h4>

  return (
    <PageTemplate date={ stateDate } setDate={ setStateDate }>
      { stateShiurData }
    </PageTemplate>
  );
}

export default Shiur;
